import {
  AmazonCodeCommitForm,
  AmazonS3Form,
  BeanstalkForm,
  BitbucketServerForm,
  GitHubEnterpriseForm,
  GitlabPrivateForm,
} from '@/components/Integration/Setup';

export const customIntegrationSetupMap = {
  github_server: {
    title: 'GitHub Enterprise',
    description: 'Enter your GitHub Enterprise access token details below.',
    form: GitHubEnterpriseForm,
  },
  gitlab_server: {
    title: 'GitLab Self-Managed',
    description: 'Enter your GitLab Self-Managed access token details below.',
    form: GitlabPrivateForm,
  },
  bitbucket_server: {
    title: 'Bitbucket Server',
    description: 'Enter your Bitbucket Server app password details below.',
    form: BitbucketServerForm,
  },
  codecommit: {
    title: 'Amazon CodeCommit',
    description: 'Enter your access credentials below.',
    form: AmazonCodeCommitForm,
  },
  beanstalk: {
    title: 'Beanstalk',
    description: 'Enter your Beanstalk credentials below.',
    form: BeanstalkForm,
  },
  aws: {
    title: 'Amazon S3',
    description: 'Enter your access credentials below.',
    form: AmazonS3Form,
  },
} as const;
